const values = [
  "None",
  "GpuAnimation",
  "BeamAnimation",
  "ParticleAnimation",
  "Sound",
  "PropModel",
];
export default values;
